import { Component, OnInit,} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActionSheetController } from "@ionic/angular";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { ViewDocumentNewComponent } from "./view-document-new/view-document-new.component";
import { ProfileDetailService } from "src/app/services/profile-detail.service";
import { ProfileResponse } from "src/app/model/profile-response.model";
import { ProfileDocumentModel } from "src/app/model/profile-document.model";

@Component({
  selector: "app-profile-details-new",
  templateUrl: "./profile-details-new.component.html",
  styleUrls: ["./profile-details-new.component.scss"],
})
export class ProfileDetailsNewComponent implements OnInit {
  esigned: boolean = false;
  profile: ProfileResponse;
  activeLangIndex: number = 0;
  photo: SafeResourceUrl;
  searchedPanNo: string;
  pan: string;

  constructor(private profileDetailService: ProfileDetailService, private dialog: MatDialog,
    public actionSheetController: ActionSheetController,
    private domSanitizer: DomSanitizer, private router: Router,
  ) {}
  
  ngOnInit(): void {
    
  }

  getDocuments() {
    if(this.searchedPanNo && this.searchedPanNo.length === 10) {
      this.profileDetailService.getQuestionProfiles(this.searchedPanNo)
      .subscribe((data) => {  
        if(data.status === 'SUCCESS') {
          this.profile = data;
          this.pan = this.searchedPanNo;
          this.esigned = data.esigned;
          this.fetchPhoto();
        }
        else {
          this.profileDetailService.errorToast(data.errorMessage);
        }
      }, error => {
        // this.registrationStepService.frontendWarningToast("warning-unable-to-fetch-profile-details", true);
      });
    }
    else {
      this.pan = null;
      this.profileDetailService.errorToast("Please enter valid PAN");
    }
  }

  fetchPhoto() {
    this.profileDetailService.fetchPhoto(this.pan)
    .subscribe((data) => {  
      if(data.status === 'SUCCESS') {
        const byteArray = new Uint8Array(
          atob(data.fileBase64)
            .split("")
            .map((char) => char.charCodeAt(0))
        );
        let blob = new Blob([byteArray], { type: "image/png" });
        this.photo = this.domSanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
      }
      else {
        this.profileDetailService.errorToast(data.errorMessage);
      }
    }, error => {
      
    });
  }

  async presentActionSheet(document: ProfileDocumentModel) {
    let actionSheetOptions = [
      {
        cssClass: "first-button",
        text: "View",
        icon: "eye",
        data: 10,
        handler: () => {
          this.viewDocument(document);
        },
      },
      {
        cssClass: "last-button",
        text: "Cancel",
        icon: "close",
        role: "cancel",
        handler: () => {
          
        },
      },
    ];
    actionSheetOptions = actionSheetOptions.filter(a => a.text !== 'Edit' || (a.text == 'Edit' && document.editable == 'Y'));
    const actionSheet = await this.actionSheetController.create({
      header: document.displayOnProfile.split("|||")[this.activeLangIndex] + " - ( " + document.verificationStatus + " )",
      cssClass: "my-custom-class",
      buttons: actionSheetOptions,
    });
    await actionSheet.present();
  }

  async viewDocument(document: ProfileDocumentModel) {
    this.profileDetailService.fetchQuestionDoc(this.pan, document.questionCode)
    .subscribe((data) => {  
      if(data.status === 'SUCCESS') {
        const byteArray = new Uint8Array(
          atob(data.fileBase64)
            .split("")
            .map((char) => char.charCodeAt(0))
        );
        if(data.fileType == 'IMAGE') {
          let blob = new Blob([byteArray], { type: "image/png" });
          let fileURL = URL.createObjectURL(blob);
          setTimeout(() => {
            let imageUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(fileURL);
            let documentDiag = this.dialog.open(ViewDocumentNewComponent, {
              disableClose: true,
              width: "600px",
              data: [document.displayOnProfile.split('|||'), document.answer, imageUrl, null],
            });
          }, 100);
        }
        else if(data.fileType == 'PDF') {
          let file = new Blob([byteArray], {type: 'application/pdf'});
          setTimeout(() => {
            let selectedPdf = this.domSanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(file));
            let documentDiag = this.dialog.open(ViewDocumentNewComponent, {
              disableClose: true,
              width: "600px",
              data: [document.displayOnProfile.split('|||'), document.answer, null, null, selectedPdf],
            });
          }, 100);
        }
      }
      else {
        this.profileDetailService.errorToast(data.errorMessage);
      }
    }, error => {
      
    });
  }


}
